// Fechas y números del catálogo de etiquetas con las reglas de C24: Hoy, Ayer, el nombre del día hasta 6 días y después
// «21 oct. 2026» (en-US «Oct 21, 2026»); el title lleva fecha y hora. Los números con separador de miles («1,000»).

const esMonths = ["ene.", "feb.", "mar.", "abr.", "may.", "jun.", "jul.", "ago.", "sep.", "oct.", "nov.", "dic."];
const enMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const esDays = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
const enDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const english = (locale: string) => locale.toLowerCase().startsWith("en");
const dayStart = (date: Date) => Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());

/** «21 oct. 2026» o «Oct 21, 2026». */
export function longDate(value: Date, locale: string): string {
  return english(locale)
    ? `${enMonths[value.getMonth()]} ${value.getDate()}, ${value.getFullYear()}`
    : `${value.getDate()} ${esMonths[value.getMonth()]} ${value.getFullYear()}`;
}

/** La fecha de una fila: Hoy, Ayer, el día de la semana (2 a 6 días) o la fecha larga. */
export function createdLabel(iso: string, locale: string, today: string, yesterday: string, now = new Date()): string {
  const value = new Date(iso);
  const days = Math.round((dayStart(now) - dayStart(value)) / 86_400_000);
  if (days === 0) return today;
  if (days === 1) return yesterday;
  if (days >= 2 && days <= 6) return (english(locale) ? enDays : esDays)[value.getDay()]!;
  return longDate(value, locale);
}

/** El title de la fecha: «21 oct. 2026, 3:18 a. m.» o «Oct 21, 2026, 3:18 AM». */
export function createdTitle(iso: string, locale: string): string {
  const value = new Date(iso);
  const hour = value.getHours() % 12 || 12;
  const minute = String(value.getMinutes()).padStart(2, "0");
  const morning = value.getHours() < 12;
  const time = english(locale) ? `${hour}:${minute} ${morning ? "AM" : "PM"}` : `${hour}:${minute} ${morning ? "a. m." : "p. m."}`;
  return `${longDate(value, locale)}, ${time}`;
}

/** «1/10» (mismo año) o «1/12/25» (otro año), para la píldora del rango de fechas. */
export function shortDay(day: string, now = new Date()): string {
  const [year, month, date] = day.split("-").map(Number) as [number, number, number];
  return year === now.getFullYear() ? `${date}/${month}` : `${date}/${month}/${String(year).slice(2)}`;
}

/** Número con separador de miles (C24): 1,000 y 15,012. */
export const count = (value: number) => new Intl.NumberFormat("en-US").format(value);
